import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Context } from '../../../Context'
import { Dialog } from '@progress/kendo-react-dialogs'
import { DropDownList } from '@progress/kendo-react-dropdowns'
import ButtonHLPure from '../buttonHL/buttonHL.pure'
import { Grid } from '@material-ui/core'
import LabelPure from '../label/label.pure'
import { useTranslation } from 'react-i18next'
import { CatalogService, ClientService } from '../../../services'
import ModalUtil from '../modal/modal.util'

const DialogCategory = () => {
    const tokenData = JSON.parse(localStorage.getItem('token'))
    const token = tokenData?.accessToken
    const url = process.env.REACT_APP_ETICKET_API;
    const catalogService = new CatalogService(url);
    const clientService = new ClientService(url);
    const modalUtil = new ModalUtil();

    const { t } = useTranslation();
    const { t: trans } = useTranslation('clients-dashboard', { keyPrefix: 'categoryDialog' });
    const { t: tCommon, i18n } = useTranslation('common');
    const { showCategoryDialog, setShowCategoryDialog, saveCategory } = useContext(Context)
    const closeDialog = () => setShowCategoryDialog(false);

    const [isLoading, setIsLoading] = useState(true);
    const [categories, setCategories] = useState();
    const [categorySelected, setCategorySelected] = useState();

    const handleCategorySelected = (e) => setCategorySelected(e.value)

    const onSave = async () => {
        try {
            closeDialog();
            modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))

            let clientProfileInformation = new FormData();
            const category = categories.find((category) => category.id === categorySelected.id)

            clientProfileInformation.append("categoryId", category.id)
            const updatedClientProfileInformation = await clientService.updateClientProfileInformation(token, clientProfileInformation)
            if (updatedClientProfileInformation && updatedClientProfileInformation.data && Number(updatedClientProfileInformation.statusCode) === 200) {
                saveCategory(category.name)
                modalUtil.showModal('success', trans("successMessage"), t("modal.pure.title.success"))
            } else {
                throw new Error(updatedClientProfileInformation.message)
            }
        } catch (error) {
            modalUtil.showModal('error', error.message || trans("errorMessage"), t("modal.pure.title.error"), null, () => setShowCategoryDialog(true))
        }
    }

    const getCatalogClientInformation = async () => {
        const { categories } = await catalogService.getCatalogClientInformation(token)
        setCategories(categories)
        setIsLoading(false)
    }

    useEffect(() => {
        if (!token) return;
        getCatalogClientInformation();
    }, [token])

    const options = useMemo(() => {
        if (!categories) return [];
        return categories.filter(category => category.name != "uncategorized").map((category) => ({
            id: category.id,
            label: tCommon(category.name.trim()),
        }))
    }, [i18n.language, categories])

    if (!token) {
        window.location.reload()
        return null
    }

    if (!showCategoryDialog || isLoading) return <></>

    return (
        <Dialog width={400} onClose={closeDialog} className="dialogFormHLPure-container" title={trans("title")}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <p style={{ marginTop: 0 }}>{trans("message")}</p>
                    <LabelPure htmlFor="categories-dropdown" title={trans("category")} />
                    <DropDownList
                        id="categories-dropdown"
                        dataItemKey="id"
                        textField="label"
                        data={options}
                        value={categorySelected}
                        onChange={handleCategorySelected}
                        className="eticket-dropdown-field"
                    />
                </Grid>
                <Grid item xs={12} className='button-actions'>
                    <ButtonHLPure primary nameBtn={tCommon("save")} onClick={onSave} />
                </Grid>
            </Grid>
        </Dialog>
    )
}

export default DialogCategory